import DashboardService from '@/services/DashboardService';
const state = {
  summary: {
    new: 0,
    totalLeads: 0,
    openedJobcard: 0,
    booked: 0,
    completed: 0,
    confirmed: 0,
    cancelled: 0,
    followUp: 0,
  },
};

const getters = {
  getLeadSummary: (state) => state.summary,
};

const actions = {
  async fetchLeadSummary({ commit }) {
    try {
      const response = await DashboardService.getDashboardLeads();
      commit('setLeadSummary', response.data);
    } catch (error) {
      // Error logging (just like using Logger in Java)
    }
  },

  updateLeadSummary({ commit }, updatedData) {
    commit('setLeadSummary', updatedData);
  },
};

const mutations = {
  setLeadSummary(state, data) {
    state.summary = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
